module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_Jan2020-0e1e649ebba586b36673ca8694feb7af.pdf";